import * as React from 'react';
import { Form } from 'react-bootstrap';
import RushProcessing from '../form/RushProcessing';
import { useEffect } from 'react';
import { config } from '_config';
import { useRouter } from 'next/dist/client/router';
import RushProduct from '../form/RushProduct';
import styled from 'styled-components';

const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
  gap: 16px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export default function TrademarkStep6({
  state,
  onChange,
  trademarkRushProcessing,
  validated,
}) {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setTimeout(() => {
      window.scroll(0, 0);
    }, 50);
  }, []);
  const router = useRouter();

  const isV4 = router.pathname.includes('registration-trademark-4');
  const handleChange = (e) => {
    const event = { target: { name: 'rushProcessing', value: e } };
    onChange(event);
  };
  return (
    <div className="question step-6">
      <Form id="TrademarkForm" noValidate validated={validated}>
        <h2>Add rush processing to expedite your application</h2>
        {config.skin !== 'v2-basic' && (
          <h2>
            You’re nearly finished!
            <br />
            Do you need your order processed faster?
          </h2>
        )}

        {trademarkRushProcessing && isV4 ? (
          <div className="rush-processing">
            <StyledBoxContainer>
              {trademarkRushProcessing
                .filter((item) =>
                  item.exist.some((opt) => opt.option === state.option)
                )
                .map((product, idx) => {
                  const {
                    customerName,
                    customerDescription,
                    checkboxTitle,
                    code,
                    exist,
                  } = product;
                  const curOption = exist.find(
                    (item) => item.option === state.option
                  );
                  return (
                    <RushProduct
                      key={idx}
                      customerName={customerName}
                      customerDescription={customerDescription}
                      checkboxTitle={checkboxTitle}
                      code={code}
                      price={curOption.price}
                      onChange={handleChange}
                      selected={state.rushProcessing}
                      state={state}
                    />
                  );
                })}
            </StyledBoxContainer>
          </div>
        ) : (
          <RushProcessing
            trademarkRushProcessing={trademarkRushProcessing}
            onChange={onChange}
            state={state}
          />
        )}
      </Form>
    </div>
  );
}
